/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid } from '@mui/material';
import '../ShiftAndSchedule.css';

import { useAppSelector } from '../../../../infra/hooks';
import SwapShift2 from '../../../../domain/myProfile/shiftAndSchedule/ShiftAndScheduleList/v2-ui/swap-shift/SwapShift';

interface shiftProp {
  trans?: any;
  i18n?: any;
}

const ShiftAndSchedulePresenter = ({ i18n }: shiftProp) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <Grid
      container
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        marginTop: isHRView ? '' : '4em',
        width: '100vw',
        paddingRight: '8em',
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: '#F5F5FA',
          width: '100%',
          padding: '1.75em',
          marginLeft:
            isHRView && i18n.language == 'en'
              ? '11em'
              : !isHRView && i18n.language == 'en'
                ? '14em'
                : '',
          marginRight: i18n.language == 'ar' ? '15em' : '',
          overflowY: 'auto',
        }}
      >
        <Grid
          container
          style={{
            paddingLeft: isHRView ? '1em' : '',
          }}
        >
          <Grid
            item
            sx={{
              width: '100%',
              height: '80px',
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <SwapShift2 />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default ShiftAndSchedulePresenter;
